import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, ArrowRight } from "lucide-react";
import api from "../../lib/api";

export function SavedTab({ onChange }) {
  const [items, setItems] = useState(null);

  const load = () => api.get("/member/favorites").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const remove = async (slug) => {
    await api.delete(`/member/favorites/${slug}`);
    setItems((cur) => cur.filter((s) => s.slug !== slug));
    onChange && onChange();
  };

  if (items === null) return <p className="text-[#8A9492]">Loading…</p>;

  return (
    <div data-testid="saved-tab">
      <h2 className="font-heading text-2xl font-light text-ink mb-6">Saved treatments</h2>
      {items.length === 0 ? (
        <div className="bg-white rounded-2xl p-10 border border-slate-100 text-center" data-testid="saved-empty">
          <Heart className="h-8 w-8 text-[#c9c4dc] mx-auto" />
          <p className="text-[#8A9492] mt-3">No saved treatments yet.</p>
          <Link to="/services" className="text-iri-mid underline mt-2 inline-block">Browse services →</Link>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((s) => (
            <div key={s.slug} className="bg-white rounded-2xl overflow-hidden border border-slate-100 hover-lift" data-testid={`saved-${s.slug}`}>
              <div className="img-zoom aspect-[4/3] overflow-hidden relative">
                <img src={s.image} alt={s.name} className="w-full h-full object-cover" />
                <button onClick={() => remove(s.slug)} data-testid={`unsave-${s.slug}`}
                  className="absolute top-3 right-3 h-9 w-9 rounded-full bg-white/90 flex items-center justify-center hover:bg-white">
                  <Heart className="h-4 w-4 fill-iri-mid text-iri-mid" />
                </button>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-medium text-ink">{s.name}</h3>
                <p className="text-sm text-iri-mid mt-1">{s.price}</p>
                <Link to={`/services/${s.slug}`} className="inline-flex items-center gap-1 text-sm text-ink mt-3 hover:gap-2 transition-all">
                  View treatment <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
